module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("UjePP"))).then(() => parcelRequire('ikE14'));